import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarYearsListCellFn = /* @__PURE__ */ createRecipe('calendar-years-list-cell', {}, [])

const calendarYearsListCellVariantMap = {}

const calendarYearsListCellVariantKeys = Object.keys(calendarYearsListCellVariantMap)

export const calendarYearsListCell = /* @__PURE__ */ Object.assign(memo(calendarYearsListCellFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarYearsListCell',
  __getCompoundVariantCss__: calendarYearsListCellFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarYearsListCellVariantKeys,
  variantMap: calendarYearsListCellVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarYearsListCellVariantKeys)
  },
  getVariantProps: calendarYearsListCellFn.getVariantProps,
})